"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ImageDrop;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _FileDropButton = _interopRequireDefault(require("../FileDropButton"));
function ImageDrop(_ref) {
  var _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? 'image/jpeg, image/png, image/svg+xml' : _ref$accept,
    addImageKey = _ref.addImageKey,
    _ref$FileDropButtonPr = _ref.FileDropButtonProps,
    FileDropButtonProps = _ref$FileDropButtonPr === void 0 ? {} : _ref$FileDropButtonPr,
    id = _ref.id,
    onChange = _ref.onChange,
    replaceImageKey = _ref.replaceImageKey,
    value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_FileDropButton.default, (0, _extends2.default)({
    accept: accept,
    id: id,
    onDrop: function onDrop(acceptedFiles) {
      return acceptedFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.onload = function () {
          var image = new Image();
          image.src = reader.result;
          image.onload = function () {
            return onChange("url(".concat(image.src, ")"));
          };
        };
        reader.onabort = function () {
          return console.log('file reading was aborted');
        };
        reader.onerror = function () {
          return console.log('file reading has failed');
        };
        reader.readAsDataURL(file);
      });
    },
    textKey: value ? replaceImageKey || 'actions.replaceImage' : addImageKey || 'actions.addImage'
  }, FileDropButtonProps));
}